import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const CONSENT_KEY = 'connecto_analytics_consent';

const getStoredConsent = () => {
  try {
    return window.localStorage.getItem(CONSENT_KEY);
  } catch (error) {
    return null;
  }
};

const CookieConsent = () => {
  const { language } = useLanguage();
  const [consent, setConsent] = useState('loading');

  useEffect(() => {
    if (window.navigator.userAgent.includes('ReactSnap')) {
      setConsent('denied');
      return;
    }
    setConsent(getStoredConsent());
  }, []);

  if (consent !== null) return null;

  const updateConsent = (choice) => {
    if (typeof window.setConnectoAnalyticsConsent === 'function') {
      window.setConnectoAnalyticsConsent(choice);
    }
    setConsent(choice);
  };

  const isArabic = language === 'ar';

  return (
    <aside
      className="fixed bottom-4 left-4 right-4 z-[10000] mx-auto max-w-3xl rounded-2xl border border-slate-200 bg-white p-4 text-slate-800 shadow-2xl"
      aria-label={isArabic ? 'إعدادات ملفات تعريف الارتباط' : 'Cookie settings'}
    >
      <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="m-0 text-sm leading-6">
          {isArabic
            ? 'نستخدم التحليلات وملفات تعريف الارتباط الاختيارية لتحسين تجربتك وقياس أداء الموقع.'
            : 'We use optional analytics and cookies to improve your experience and measure site performance.'}
          {' '}
          <Link className="font-semibold text-blue-700 underline" to="/privacy/">
            {isArabic ? 'سياسة الخصوصية' : 'Privacy policy'}
          </Link>
        </p>

        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-semibold hover:bg-slate-50"
            onClick={() => updateConsent('denied')}
          >
            {isArabic ? 'رفض' : 'Reject'}
          </button>
          <button
            type="button"
            className="rounded-lg bg-blue-700 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-800"
            onClick={() => updateConsent('granted')}
          >
            {isArabic ? 'قبول' : 'Accept'}
          </button>
        </div>
      </div>
    </aside>
  );
};

export default CookieConsent;
